import api from '@/services/api'
const state = {
  vectors: {
    EE: { details: false },
    gas: { details: false },
  },
  reports: [],
  selectedReport: null,
  editMode: false
}
const getters = {
  getReportsList: state => {
    return state.reports;
  },
  selectedReport: state => {
    return state.selectedReport;
  },
  editMode: state => {
    return state.editMode
  }
}

const actions = {
  sendReportToEmails({ commit }, data) {
    return new Promise((resolve, reject) => {
      api().post("/report/email", data).then((response) => {
        try {
          resolve(response.data);
        } catch (e) {
          reject(e);
        }
      })
    })
  },
  getReportBuilder({ commit }, data) {
    return new Promise((resolve, reject) => {
      commit('setSelectedReport', undefined);
      if (data && !data.id) {
        return;
      }
      api().get(`/report-builder/${data.id}?month=${data.month}`).then((response) => {
        try {
          let report = response.data.data;
          report.data = JSON.parse(report.data);
          commit('setSelectedReport', report);
          resolve(report);
        } catch (e) {
          reject(e);
        }
      })
    })
  },

  addReportBuilder({ commit }, payload) {
    return new Promise((resolve) => {
      payload.data = JSON.stringify(payload.data);
      api().post(`/report-builder/add`, payload).then((response) => {
        let report = response.data.data;
        report.data = JSON.parse(report.data);
        commit('addNewReport', report);
        resolve(report);
      })
    })
  },

  duplicateReportBuilder({ commit }, payload) {
    return new Promise((resolve) => {
      api().post(`/report-builder/${payload.id}/duplicate`, { name: payload.name }).then((response) => {
        let report = response.data.data;
        report.data = JSON.parse(report.data);
        commit('addNewReport', report);
        resolve(report);
      })
    })
  },

  updateReportBuilder({ commit }, data) {
    return new Promise((resolve) => {
      data.data = JSON.stringify(data.data);
      api().post(`/report-builder/update`, data).then((response) => {
        let report = response.data.data;
        report.data = JSON.parse(report.data);
        commit('updateReport', report);
        commit('setSelectedReport', report);
        resolve(report);
      })
    })
  },

  updateReportBuilderSilently({ commit }, data) {
    return new Promise((resolve) => {
      data.data = JSON.stringify(data.data);
      api().post(`/report-builder/update`, data).then((response) => {
        resolve(true);
      })
    })
  },


  listReportBuilder({ commit }) {
    return new Promise((resolve) => {
      api().post(`/report-builder/list`).then((response) => {
        let reports = response.data.data;
        reports.map(ele => {
          let data = JSON.parse(ele.data);
          ele.data = data;
          ele.type = data && data.type ? data.type : '';

          return ele;
        });
        commit('setReportList', reports)
        resolve(reports)
      })
    })
  },


  postImage({ commit, state, rootState }, payload) {
    return new Promise((resolve) => {
      api().post(`/media/${rootState.user.databaseName}/${rootState.report.selectedReport.id}`, payload).then((response) => {
        let finalResult = `/api/v1/media/${rootState.user.databaseName}/${response.data.data}`
        resolve(finalResult);
      })
    })
  },

  updateImage({ commit, state, rootState }, payload) {
    return new Promise((resolve) => {
      api().post(`/media/${rootState.user.databaseName}/${rootState.report.selectedReport.id}/${payload.identity}`, payload.formData).then((response) => {
        let finalResult = `/api/v1/media/${rootState.user.databaseName}/${response.data.data}`
        resolve(finalResult);
      })
    })
  },
  deleteImage({ commit, state, rootState }, payload) {
    return new Promise((resolve) => {
      api().delete(`/media/${rootState.user.databaseName}/${payload}`).then((response) => {
        resolve(true);
      })
    })
  },
  deleteReportBuilder({ commit }, id) {
    return new Promise((resolve) => {
      api().post(`/report-builder/${id}/delete`).then((response) => {
        commit('deleteReport', id)
        resolve(true)
      })
    })
  },

  ipg({ commit }, data) {
    return new Promise((resolve, reject) => {
      api().post('/report/ipg', data).then((response) => {
        resolve(response.data.data)
      })
    })
  },

  ip({ commit }, data) {
    return new Promise((resolve, reject) => {
      api().post('/report/ip', data).then((response) => {
        resolve(response.data.data)
      })
    })
  },

  summary({ commit }, data) {
    return new Promise((resolve, reject) => {
      api().post('/report/summary', data).then((response) => {
        resolve(response.data.data)
      })
    })
  },

  categories({ commit }, data) {
    return new Promise((resolve, reject) => {
      api().post('/report/categories', data).then((response) => {
        resolve(response.data.data)
      })
    })
  },

  setVectorDetails({ commit }, data) {
    commit('setVectorDetails', data)
  },

  toggleEditMode({ commit }, status = false) {
    commit('toggleEditMode', status)
  },

  updateReportSectionInVuex({ commit }, data) {
    commit('updateReportSectionInVuex', data)
  },
  updateReportInVuex({ commit }, data) {
    commit('updateReportInVuex', data)
  },
}

const mutations = {
  setVectorDetails(state, v) {
    state.vectors[v.vector] = v.details
  },
  setReportList(state, list) {
    state.reports = list;

  },
  setImageList(state, list) {
    state.reports = list;
  },
  addNewReport(state, report) {
    let reports = [...state.reports];
    reports.push(report);
    state.reports = reports;
  },
  setSelectedReport(state, report) {
    state.selectedReport = report;
  },
  updateReport(state, report) {
    let index = state.reports.map(e => e.id).indexOf(report.id);
    if (index >= 0) {
      let reports = [...state.reports];
      reports[index] = report;
      state.reports = reports;
    }
  },
  toggleEditMode(state, status) {
    state.editMode = status
  },
  updateReportSectionInVuex(state, payload) {
    let reportId = payload.id;
    let index = state.reports.map(e => e.id).indexOf(reportId);
    if (index >= 0) {
      let report = [...state.reports][index];
      let pages = report.data.pages;
      let newSection = payload.section;
      let sections = pages ? pages[payload.pageIndex].sections : [];
      sections.push(newSection);
      report.data.pages[payload.pageIndex].sections = sections;

      state.reports[index] = report;
      state.selectedReport = { ...report };
    }
  },
  updateReportInVuex(state, report) {
    state.selectedReport = report;
  },
  deleteReport(state, id) {
    let reports = [...state.reports];
    let index = reports.map(e => e.id).indexOf(id);
    if (index >= 0) {
      reports.splice(index, 1);
      state.reports = reports;
      state.selectedReport = undefined;
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}



// WEBPACK FOOTER //
// ./src/store/modules/report.js